import React from 'react';

import { ContainerConfig } from '../../pages/types';
import ContainerEditor from '../ContainerEditor';

interface ContainerEditorWrapperProps {
  container?: ContainerConfig;
  onPropChange: (key: string, value: any) => void;
  configParam: string;
  handleUpload: (blob: Blob, filename: string) => Promise<boolean>;
}

const ContainerEditorWrapper: React.FC<ContainerEditorWrapperProps> = ({
  container = { items: [] },
  onPropChange,
  configParam,
  handleUpload,
}) => {
  return (
    <ContainerEditor
      container={container}
      onChange={(updatedContainer) => {
        onPropChange('container', updatedContainer);
      }}
      configParam={configParam}
      handleUpload={handleUpload}
    />
  );
};

export default ContainerEditorWrapper;
